import { PROFILE_URL, ORGANIZATION_URL, USERS_URL, AI_VERIFICATION_CALLS_URL } from './constants'


export const checkIfAccountSection = (location) => {
    return (location.pathname === PROFILE_URL ||
        location.pathname === ORGANIZATION_URL ||
        location.pathname === USERS_URL ||
        location.pathname === AI_VERIFICATION_CALLS_URL) ? true : false

}